
import { useState, useEffect, Fragment} from "react";

import Config from "../Config";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


import GroupNew from "../modules/kids/GroupNew";

function InputComboGrupy(props)
{

    var cData = Config.getFromBuffer(Config.cache_grups,3600, props.userData );
   
    var defShowAll = 0;
    if(props.all != undefined && props.all == 1 ) defShowAll = 1;
    const [showAll, setShowAll] = useState(defShowAll);

    const [gr, setGr] = useState(cData);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

 

    const [selected, setSelected] = useState(null);
    

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            
        };
       

        fetch( Config.url + '/rest_v1_kids,gr', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);                                                                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

   

    const checkAndChange = (e) =>
    {                       


        var xName  = e.target.getAttribute("name");
        var xChecked  = e.target.checked;                     


        var tArr = xName.split("@");
        var inx = tArr[1];


        console.log("XXX",xName, xChecked, inx);

        var ttt = selected;

        if( ttt[inx]["selected"]  == 1)
        {
            ttt[inx]["selected"] = 0;
        }else
        {
            ttt[inx]["selected"] = 1;
        }
       

       setSelected( JSON.parse( JSON.stringify(ttt) ) );

      //  setVal(v);
        

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name,  JSON.parse( JSON.stringify(ttt) ) , correct,'combo');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val == '_x_') correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {
 
 
    })


 


    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setGr(null);    
        }


 
    

    
    if( gr == null ||  gr.length == 0 )
    {
        getGr();
        
        return <fieldset>
                    ....                  
             <br/>
             <span className="form_err">  &nbsp; </span>                
           </fieldset>                     
        
    }

    

    if(selected == null )
    {
            var s = new Array();


            for(var k=0; k < gr.length; k++)
            {
                var isChecked = 0;

                for(var g=0; g<val.length; g++)
                {
                    if(val[g].id == gr[k].v ) {
                        isChecked = 1;
                    }
                }

                if(gr[k].v != '_x_')
                {
                    s.push({
                        id: gr[k].v,
                        nazwa: gr[k].title,
                        selected: isChecked,
                    });
                }                
            }

            setSelected(s);
    }


    

    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    var cnX = cn;
 

 
    var readyGR = new Array();
    readyGR = gr;

   // console.log("selected",selected);
   // console.log("gr",gr);
   // console.log("val",val);

    if( Array.isArray(selected) )
    {

        return <Fragment>
                <br/>         
                {
                    selected.map(  (item, ix) => {

                            var cc = "";
                            if(item.selected == 1) {
                                cc = "checked"
                            }

                            return <fieldset className="inline_block">
                                        &nbsp; <input type="checkbox" name={ "item@"+ix } checked={cc}  onChange={checkAndChange}  /> {item.nazwa} &nbsp;
                            </fieldset>
                    } )  
                }

        </Fragment>
    }else 
    {
        return <span>
            ..........
        </span>
    }

  

}


export default InputComboGrupy;

